import React from 'react';
import { Link } from 'react-router-dom';

const WebDevelopment = () => (
  <section className="min-h-screen bg-[#0f1a29] py-20 px-4 flex flex-col items-center justify-center">
    <div className="max-w-3xl w-full bg-white rounded-2xl shadow-2xl p-10 relative z-10">
      <h1 className="text-4xl font-bold text-brand-blue mb-6 text-center">Web Development</h1>
      <p className="text-lg text-gray-700 mb-6 text-center">
        Build a modern, responsive website that converts visitors into customers. We deliver beautiful, high-performing sites tailored to your business goals.
      </p>
      <ul className="list-disc pl-6 space-y-3 text-gray-800 mb-8">
        <li>Custom website design and development</li>
        <li>Responsive and mobile-first builds</li>
        <li>eCommerce solutions and integrations</li>
        <li>Performance optimization and security</li>
        <li>Ongoing maintenance and support</li>
      </ul>
      <div className="flex flex-col sm:flex-row gap-4 justify-center mt-8">
        <Link to="/" className="px-6 py-3 bg-brand-blue text-white rounded-lg shadow hover:bg-blue-700 transition font-semibold text-center">Back to Home</Link>
        <Link to="#contact" onClick={e => { e.preventDefault(); const section = document.getElementById('contact'); if (section) section.scrollIntoView({ behavior: 'smooth' }); }} className="px-6 py-3 bg-blue-100 text-brand-blue rounded-lg shadow hover:bg-blue-200 transition font-semibold text-center">Contact Us</Link>
      </div>
    </div>
  </section>
);

export default WebDevelopment; 